var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoorRevolving = function SvgDoorRevolving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M16.3 18.63a2 2 0 0 1-2.98 1.74l-4.96-2.8a2 2 0 0 1-1.02-1.73V6.45a2 2 0 0 1 2.99-1.74l4.95 2.8a2 2 0 0 1 1.02 1.74z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M16.3 8.08c-.21.11-.13.43.1.43l1.79.02c.09 0 .18.02.26.06l6.37 2.7c.2.09.44-.07.43-.29V6.45a2 2 0 0 0-2.98-1.74z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M16.3 10.7a2 2 0 0 1 2.78-1.84l6.32 2.67a2 2 0 0 1 1.22 1.84v13a2 2 0 0 1-2.78 1.84l-6.32-2.67a2 2 0 0 1-1.22-1.84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.67,
    d: "M16.3 10.7a2 2 0 0 0-2.78-1.84l-6.31 2.67a2 2 0 0 0-1.22 1.84v13a2 2 0 0 0 2.78 1.84l6.31-2.67a2 2 0 0 0 1.22-1.84z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.6 14.5c-.39-.22-.85.08-.85.55v1.55c-.78.3-1.71.59-2.47.59-.87 0-1.92-.33-2.76-.67-.7-.29-1.53.22-1.53.98v1.47c0 .3.14.6.4.76a7.66 7.66 0 0 0 3.96 1.16c.94 0 1.76-.2 2.4-.45v1.58c0 .64.77.87 1.07.32l2.63-4.73a1.3 1.3 0 0 0-.45-1.74z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.25 20.83a6.7 6.7 0 0 0 1.5-.39v1.58c0 .64.77.87 1.07.32l2.63-4.73 1.31.73-2.63 4.73a2.04 2.04 0 0 1-2.39 1 2.1 2.1 0 0 1-1.46-1.73A9.16 9.16 0 0 1 10.59 21a2.37 2.37 0 0 1-1.1-2.03V17.5c0-1.95 2.01-3 3.59-2.37a6.7 6.7 0 0 0 2.2.56c.26 0 .6-.06.97-.17v-.47c0-1.41 1.53-2.75 3.1-1.86l2.4 1.38a2.8 2.8 0 0 1 1.01 3.77l-1.31-.73a1.3 1.3 0 0 0-.45-1.74l-2.4-1.37c-.39-.22-.85.08-.85.55v1.55c-.78.3-1.71.59-2.47.59-.87 0-1.92-.33-2.76-.67-.7-.29-1.53.22-1.53.98v1.47c0 .3.14.6.4.76a7.66 7.66 0 0 0 4.86 1.1",
    clipRule: "evenodd"
  })));
};
export default SvgDoorRevolving;